import { createAction } from 'typesafe-actions';
import {
  BankAccountManageResponse,
  BankAccountCreatePayload,
  BankAccountEntityResponse,
  BankAccountSummaryResponse,
} from 'types/dto';
import { SortInfo } from 'types/sort';
import { EntityUpdatePayload } from 'types/transport';

export enum AccountAction {
  Clear = 'ACCOUNT_CLEAR',
  Create = 'ACCOUNT_CREATE',
  Created = 'ACCOUNT_CREATED',
  Error = 'ACCOUNT_ERROR',
  ListRequest = 'ACCOUNT_LIST_REQUEST',
  ListResponse = 'ACCOUNT_LIST_RESPONSE',
  Request = 'ACCOUNT_REQUEST',
  Response = 'ACCOUNT_RESPONSE',
  Sort = 'ACCOUNT_SORT',
  SummaryRequest = 'ACCOUNT_SUMMARY_REQUEST',
  SummaryResponse = 'ACCOUNT_SUMMARY_RESPONSE',
  Update = 'ACCOUNT_UPDATE',
  Updated = 'ACCOUNT_UPDATED',
}

export const accountClear = createAction(AccountAction.Clear)();
export const accountCreate = createAction(AccountAction.Create)<BankAccountCreatePayload>();
export const accountCreated = createAction(AccountAction.Created)();
export const accountError = createAction(AccountAction.Error)<Error>();
export const accountListRequest = createAction(AccountAction.ListRequest)();
export const accountListResponse = createAction(
  AccountAction.ListResponse,
)<BankAccountManageResponse>();
export const accountRequest = createAction(AccountAction.Request)<string>();
export const accountResponse = createAction(AccountAction.Response)<BankAccountEntityResponse>();
export const accountSort = createAction(AccountAction.Sort)<SortInfo>();
export const accountSummaryRequest = createAction(AccountAction.SummaryRequest)();
export const accountSummaryResponse = createAction(
  AccountAction.SummaryResponse,
)<BankAccountSummaryResponse>();
export const accountUpdate = createAction(AccountAction.Update)<
  EntityUpdatePayload<BankAccountCreatePayload>
>();
export const accountUpdated = createAction(AccountAction.Updated)();
